/** 是否为当前统一论坛模块路由 */
export const isForumRouteName = (routeName) =>
  typeof routeName === 'string' && routeName.indexOf('forum-') === 0;

export const isForumRoute = (route) => {
  if (!route) return false;
  const routeName = typeof route.name === 'string' ? route.name : '';
  const routePath = route.path || '';
  return isForumRouteName(routeName) || routePath === '/forum' || routePath.indexOf('/forum/') === 0;
};

/** keep-alive 缓存 key：按 groupId / postId 等区分，避免复用错误页面状态 */
export const getForumRouteCacheKey = (route) => {
  if (!isForumRoute(route)) return '';
  const path = route.path || '';
  if (path === '/forum/post/create') {
    return `forum-post-create:${String(route.query.groupId || '0')}`;
  }
  const name = route.name;
  switch (name) {
    case 'forum-group':
      return `${name}:${String(route.params.groupId || '')}`;
    case 'forum-post-detail':
      return `${name}:${String(route.params.postId || '')}`;
    case 'forum-assemble':
      return `${name}:${String(route.params.assembleId || '')}`;
    case 'forum-search':
    case 'forum-post-create':
      return `${name}:${String(route.query.groupId || '0')}`;
    default:
      return String(name || path);
  }
};
